import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { backupService } from '@/api/services/backups';
import { clusterService } from '@/api/services/cluster';
import { head } from '@/router/Head';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/backups')({
  staticData: {
    title: 'Backups',
    // Overrides the inherited `account` default — the backups feature has its own owner.
    domain: 'backups',
  },
  beforeLoad: ({ params: { accountId } }) => ({
    clustersByAccountIdQuery: clusterService.listClustersQuery({
      accountId,
    }),
  }),
  // Fetching both lists runs the permissions interceptor, which throws an AccessControlError
  // (handled as a not-found) when the user lacks `read:clusters` or `read:backups`. The backups list is
  // `BackupsTable`'s own query, hoisted so a refusal lands on the page instead of inside the section.
  loader: ({ context: { queryClient, clustersByAccountIdQuery }, params: { accountId } }) =>
    Promise.all([
      queryClient.ensureQueryData(clustersByAccountIdQuery),
      queryClient.ensureQueryData(backupService.listBackupsQuery({ accountId })),
    ]),
  head,
  component: lazyRouteComponent(() => import('./backups.component'), 'BackupsComponent'),
  pendingComponent: lazyRouteComponent(() => import('./backups.component'), 'BackupsPendingComponent'),
});
